import Components from "../components";

class StatusPageForm extends Components.Base {
  bind() {
    this.sitesSelected = this.$el.find("#sites-selected");
    this.sitesCount = parseInt(this.sitesSelected.text(), 10);
    this.on(
      "change",
      '.sites input[type="checkbox"]',
      this.siteToggled.bind(this),
    );

    this.checkInsSelected = this.$el.find("#check_ins-selected");
    this.checkInsCount = parseInt(this.checkInsSelected.text(), 10);
    this.on(
      "change",
      '.check_ins input[type="checkbox"]',
      this.checkInToggled.bind(this),
    );

    this.on("dragstart", ".draggable", this.onDragStart.bind(this));
    this.on("dragover", "tr.dropzone", this.onDragOver.bind(this));
    this.on("dragenter", "tr.dropzone", this.onDragEnter.bind(this));
    this.on("dragleave", "tr.dropzone", this.onDragLeave.bind(this));
    this.on("drop", "tr.dropzone", this.onDrop.bind(this));
    this.on("dragend", ".draggable", this.onDragEnd.bind(this));
  }

  siteToggled(evt) {
    const root = $(evt.target).parents(".site");
    root.find(".site-display-name, .site-description").toggle();
    this.sitesCount += evt.target.checked ? 1 : -1;
    this.sitesSelected.text(this.sitesCount);

    if (evt.target.checked) {
      $(evt.currentTarget).siblings(".draggable").show();
    } else {
      $(evt.currentTarget).siblings(".draggable").hide();
    }
  }

  checkInToggled(evt) {
    const root = $(evt.target).parents(".check_in");
    root.find(".check_in-display-name, .check_in-description").toggle();
    this.checkInsCount += evt.target.checked ? 1 : -1;
    this.checkInsSelected.text(this.checkInsCount);

    if (evt.target.checked) {
      $(evt.currentTarget).siblings(".draggable").show();
    } else {
      $(evt.currentTarget).siblings(".draggable").hide();
    }
  }

  /**
   * Drag and drop handlers for ordering of sites and check-ins
   */
  onDragStart(evt) {
    const $currentRow = evt.currentTarget.closest("tr");
    evt.originalEvent.dataTransfer.setData("text/plain", $currentRow.id);
    evt.originalEvent.dataTransfer.dropEffect = "move";

    // Since we're only dragging an icon, the browser shows the icon as preview. Change that to the full row.
    evt.originalEvent.dataTransfer.setDragImage($currentRow, 10, 10);

    // Tint the table; show all valid dropzones
    const $tbody = $($currentRow.closest("tbody"));
    setTimeout(() => {
      // Wrapped in a timeout because Chrome is buggy with DOM manipulation in dragstart - see https://stackoverflow.com/questions/19639969
      $tbody.find("tr:not(.dropzone)").css("opacity", "50%");
      $tbody
        .find(`tr.dropzone:not([data-element-id="${$currentRow.id}"]) td`)
        .show();
      $($currentRow.nextElementSibling).find("td").hide();
    });
  }

  onDragOver(evt) {
    evt.preventDefault();
    evt.originalEvent.dataTransfer.dropEffect = "move";
  }

  // Highlight the dropzone when you drag over it...
  onDragEnter(evt) {
    $(evt.currentTarget).css("opacity", "120%");
  }

  // ...and fade it back when you leave it
  onDragLeave(evt) {
    $(evt.currentTarget).css("opacity", "60%");
  }

  onDrop(evt) {
    evt.preventDefault();

    const currentDropZoneRow = evt.currentTarget;
    const id = evt.originalEvent.dataTransfer.getData("text/plain");
    if (id === currentDropZoneRow.dataset.elementId) {
      return;
    }

    const $tbody = currentDropZoneRow.parentElement;
    const draggedRow = document.getElementById(id);
    const attachedDropZoneRow = draggedRow.previousElementSibling;
    $tbody.insertBefore(draggedRow, currentDropZoneRow);

    // Each element must have a drop zone above it. When we move the element, we move the drop zone.
    $tbody.insertBefore(attachedDropZoneRow, draggedRow);
  }

  onDragEnd(evt) {
    const $tbody = $(evt.currentTarget.closest("tbody"));
    // Un-tint the table, and hide dropzones
    $tbody.find("tr").css("opacity", "100%");
    $tbody.find("tr.dropzone").css("opacity", "60%");
    $tbody.find("tr.dropzone td").hide();
  }
}

Components.collection.register({
  selector: ".c-status-page-form",
  klass: StatusPageForm,
});
